// External modules
import React from 'react';
import { isEmpty } from 'lodash';
import ACSelect from '../../atoms/ACSelect';

// Internal modules
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import DeleteIcon from '@material-ui/icons/Delete';

import ACButton from '../../atoms/ACButton';
import ACMedia from '../../atoms/ACMedia';
import { getMediaForUIName } from '../../common/global';

import styles from './SetAdditionalFun.module.scss';

export default class SetAdditionalFun extends React.Component {
  onChangeMediaType = (name, selectedOption) => {
    const { additionalFun = {}, onChangeAdditionalFunFunc } = this.props;
    const { value = '' } = selectedOption;
    const { media = {} } = additionalFun;
    media[name] = value;
    media.url = '';
    onChangeAdditionalFunFunc('media', media);
  };

  onUploadAdditionalFunMedia = (e) => {
    if (!e.target) return null;
    const { files = [] } = e.target;

    const mediaFor = {
      ui: getMediaForUIName().additionalFun,
      name: 'additionalFunMedia',
      s3FolderName: 'generic',
    };
    const { additionalFun = {}, uploadMediaFunc } = this.props;
    const { media = {} } = additionalFun;

    uploadMediaFunc(mediaFor, media.type || '', files[0] || {});
  };

  onChangeCategory = (name, category) => {
    if (isEmpty(category)) return null;
    const { value = '' } = category;
    this.props.onChangeAdditionalFunFunc(name, value);
  };

  onChangeAdditionalFunText = (e) => {
    if (isEmpty(e) || isEmpty(e.target)) return null;
    const { name = '', value = '' } = e.target;

    this.props.onChangeAdditionalFunFunc(name, value);
  };

  onDeleteAdditionalFun = () => {
    const { additionalFun = {}, onDeleteAdditionalFunFunc } = this.props;
    const { index } = additionalFun;

    onDeleteAdditionalFunFunc(index);
  };

  renderCategories() {
    const { additionalFun = {}, categories = [], dummyCategoryName } = this.props;
    const { category = '' } = additionalFun;

    if (isEmpty(categories)) return <div />;

    const dummyCategoryNameIndex = categories.findIndex((cat) => {
      return cat === dummyCategoryName;
    });
    if (dummyCategoryNameIndex >= 0) categories.splice(dummyCategoryNameIndex, 1);

    return (
      <div className={styles.products}>
        <span
          style={{
            fontSize: '14px',
          }}
        >
          Category
        </span>
        <ACSelect
          name="category"
          showLabel={false}
          options={categories}
          option={category}
          optionLabel="label"
          optionValue="value"
          onChangeFunc={this.onChangeCategory}
        />
      </div>
    );
  }

  render() {
    const {
      additionalFun = {},
      isModalOpen = false,
      onCloseFunc,
      onSaveAdditionalFunFunc,
      onClearAdditionalFunMediaFunc,
    } = this.props;

    const { index = -1, name = '', text = '', media = {} } = additionalFun;
    let deleteIcon = <div />;

    if (parseInt(index) >= 0) {
      deleteIcon = (
        <div className={styles.deleteIcon}>
          <DeleteIcon
            style={{
              color: '#FF765F',
            }}
            onClick={this.onDeleteAdditionalFun}
          />
        </div>
      );
    }

    return (
      <Modal open={isModalOpen} onClose={onCloseFunc}>
        <div className={styles.root}>
          <div>
            <div className={styles.fullWidthColumn}>
              <div className={styles.top}>
                <div style={{ display: 'flex' }}>
                  <h3>Set Additional Fun</h3>
                  {deleteIcon}
                </div>
                <div>
                  <CloseIcon className={styles.pointerCursor} onClick={onCloseFunc} />
                </div>
              </div>
              <div className={styles.middle}>
                <div>
                  <span className={styles.title}>Details</span>
                  <div
                    style={{
                      marginTop: '20px',
                    }}
                  >
                    {this.renderCategories()}
                    <TextField
                      name="name"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start" className={styles.adornment}>
                            Name
                          </InputAdornment>
                        ),
                      }}
                      className={styles.textField}
                      value={name}
                      onChange={this.onChangeAdditionalFunText}
                    />
                    <TextField
                      name="text"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start" className={styles.adornment}>
                            Text
                          </InputAdornment>
                        ),
                      }}
                      className={styles.textField}
                      value={text}
                      onChange={this.onChangeAdditionalFunText}
                      placeholder=""
                    />
                  </div>
                  <ACMedia
                    name="additionalFunMedia"
                    media={media}
                    adornment={styles.adornment}
                    onUploadMediaFunc={this.onUploadAdditionalFunMedia}
                    onChangeMediaTypeFunc={this.onChangeMediaType}
                    onClearMediaFunc={onClearAdditionalFunMediaFunc}
                  />
                </div>
              </div>
              <div className={styles.bottom}>
                <ACButton
                  text={'Save'}
                  icon={<SaveIcon />}
                  iconLast={true}
                  onClickFunc={onSaveAdditionalFunFunc}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
